import React,{ useState, useEffect } from 'react';
import question from './../../assets/images/questions.svg';
import CategorieFaqService from "../../service/CategorieFaq";
import {urlBase} from "../../config/Globals";
export const Foire = () => {

    const[categorieFaq, setCategorieFaq] = useState([]);
    const[loadingCategorieFaq, setLoadingCategorieFaq] = useState(1);
    const fetchCategorieFaq = async() => {
        try{
            const data = await CategorieFaqService.findAll();
            console.log(data);
            setCategorieFaq(data);
            setLoadingCategorieFaq(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchCategorieFaq();
    }, []);

    return (
        <>
            <section className="bg-light py-md-5">
                <div className="container px-4 py-5">
                    <div className="row justify-content-center">
                        <div className="col-xl-10">
                            <div className="col-12 bg-white p-4 p-xl-5 d-flex flex-column align-items-center">
                                <img src={question} className="img-fluid" alt="Foire aux questions" />
                                <h2 className="display-6 fw-sb text-center mt-3">Foire aux questions</h2>
                                <div className="fs-4 py-2"><p>Vos interrogations se portent sur :</p></div>
                                <ul className="list-unstyled d-flex flex-wrap justify-content-center gap-4 pt-5">
                                    {
                                        categorieFaq.map((categorie, index) => {
                                            return (
                                                <li><a className="btn btn-outline-custom" href={urlBase+"faq/"+categorie.id}>{categorie.titre}</a></li>
                                            )
                                        })
                                    }
                                </ul>
                                <a className="btn btn-warning mx-auto mt-4" href={urlBase+"faq"}>Voir toute la faq</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
)
}